// InventorySearchSubTabs.js
import React, { useState } from "react";
import MyInventory from "./InventoryTab";

// Define the available subtabs and their corresponding components
const subTabConfigs = {
  inventory: {
    label: "Inventory List",
    component: MyInventory,
  },
  // Example for another subtab (you can add more if needed)
  // details: {
  //   label: "Details",
  //   component: ShipmentDetailsComponent,
  // },
};

const InventorySearchSubTabs = ({
  searchQuery,
  searchTrigger,
  setTotalItems,
  totalItems,
  statusFilter,
}) => {
  // Set default selected subtab to "inventory"
  const [selectedSubTab, setSelectedSubTab] = useState("inventory");
  const currentSubTabConfig = subTabConfigs[selectedSubTab];

  return (
    <div className="w-full">
      {/* Subtab navigation */}
      <div className="border-b border-gray-200">
        <div className="flex space-x-8">
          {Object.entries(subTabConfigs).map(([key, config]) => (
            <button
              key={key}
              onClick={() => setSelectedSubTab(key)}
              className={`px-1 py-4 text-sm font-medium ${
                selectedSubTab === key
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              {config.label}
            </button>
          ))}
        </div>
      </div>
      {/* Subtab content */}
      <div>
        {currentSubTabConfig.component && (
          <currentSubTabConfig.component
            searchQuery={searchQuery}
            searchTrigger={searchTrigger}
            setTotalItems={setTotalItems}
            totalItems={totalItems}
            statusFilter={statusFilter}
          />
        )}
      </div>
    </div>
  );
};

export default InventorySearchSubTabs;
